export const MY_TAX_NOT_SELF_EMPLOYED_TITLE = 'Что-то не так';

export const MY_TAX_NOT_SELF_EMPLOYED_DESCRIPTION =
	'Не можем вас зарегистрировать. Вы пока не стали самозанятым или ошиблись при вводе ИНН';

export const MY_TAX_NOT_SELF_EMPLOYED_CHECK_INN_LABEL = 'Проверить ИНН';
